import { apiClient } from '../client';
import type {
  NotificationListResponse,
  UnreadCountResponse,
} from '@/types/profile';

export const notificationService = {
  listNotifications: async (params?: {
    page?: number;
    limit?: number;
    unreadOnly?: boolean;
  }): Promise<NotificationListResponse> => {
    try {
      const cleanParams: Record<string, any> = {};
      if (params?.page != null) cleanParams.page = params.page;
      if (params?.limit != null) cleanParams.limit = params.limit;
      if (params?.unreadOnly !== undefined) cleanParams.unreadOnly = params.unreadOnly;

      const { data } = await apiClient.get('/notifications', {
        params: Object.keys(cleanParams).length > 0 ? cleanParams : undefined,
      });
      return data;
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  },

  getUnreadCount: async (): Promise<UnreadCountResponse> => {
    try {
      const { data } = await apiClient.get('/notifications/unread-count');
      return data;
    } catch (error) {
      console.error('Error fetching unread notification count:', error);
      throw error;
    }
  },

  markAsRead: async (id: number): Promise<{ id: number }> => {
    try {
      const { data } = await apiClient.patch(`/notifications/${id}/read`);
      return data;
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  },

  markAllAsRead: async (): Promise<{ updated: number }> => {
    try {
      const { data } = await apiClient.patch('/notifications/read-all');
      return data;
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      throw error;
    }
  },
};
